import { v4 as uuidv4 } from 'uuid';

export default function executeWisRpc(socket, command, isNeedId = true) {
    if (!socket) {
        return;
    }

    try {
        const id = isNeedId ? uuidv4() : undefined;
        const message = JSON.stringify({
            id,
            ...command
        });

        socket.send(message);
    } catch (error) {
        console.error('WIS RPC error: ', {
            error,
            socket,
            command
        });
    }
}
